export default __webpack_public_path__ + "static/media/account-commingsoon.13fb1596.svg";